import React from 'react'
import { Layout, Typography, Space } from 'antd'
import siteConfig from '../config/site.config'

const { Footer } = Layout
const { Text } = Typography

/**
 * 应用底部组件
 * 显示版权信息和ICP备案号
 */
const AppFooter: React.FC = () => {
  return (
    <Footer style={{ textAlign: 'center' }}>
      <Space split=" | ">
        <Text type="secondary">{siteConfig.copyright}</Text>
        {siteConfig.icpNumber && siteConfig.icpLink && (
          <a
            href={siteConfig.icpLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: 'inherit' }}
          >
            {siteConfig.icpNumber}
          </a>
        )}
        {siteConfig.policeNumber && siteConfig.policeLink && (
          <a
            href={siteConfig.policeLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: 'inherit' }}
          >
            {siteConfig.policeNumber}
          </a>
        )}
      </Space>
    </Footer>
  )
}

export default AppFooter